var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class JustAddPowerAmp {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.deviceInfo = { inputs: [], outputs: [] };
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return {
                    videoInputs: this.deviceInfo.inputs,
                    videoOutputs: this.deviceInfo.outputs,
                };
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('jpsw -v', /jpsw\s+([\.\d]+)/i, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const input = value.slice(1);
                const output = key.slice(1);
                const match = yield this.socket.send(`jpsw -r ${output} -t ${input}`, /(\d+):(\d+)/, // responses are formatted as transmitter:receiver
                tags);
                return `a${match[1]}`;
            }),
        };
        // polling
        this.polls = [
            { intervalMs: 5000, controls: ['firmwareVersion'] },
            {
                intervalMs: 10 * 60 * 1000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    yield this.queryDeviceList(['getDeviceList', 'poll'], true);
                }),
            },
        ];
    }
    // phase callbacks
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send('jpsw -v', /jpsw\s+(.+)/i, ['onInitialize']);
            if (match[1] === undefined)
                return 'verifyFailed';
            yield this.queryDeviceList(['getDeviceList', 'initialize']);
            return 'connected';
        });
    }
    // other class methods
    queryDeviceList(tags, updateDetected = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentNumInputs = this.deviceInfo.inputs.length;
            const currentNumOutputs = this.deviceInfo.outputs.length;
            // Returns 40x151/4 for 40 transmitters, 151 receivers, and 4 switches.
            const match = yield this.socket.send(`jpsw -c`, /(\d+)x(\d+)\/(\d+)/i, tags);
            const numInputs = parseInt(match[1], 10);
            const numOutputs = parseInt(match[2], 10);
            if (numInputs === currentNumInputs && numOutputs === currentNumOutputs)
                return;
            this.deviceInfo.inputs.length = 0;
            this.deviceInfo.outputs.length = 0;
            for (let i = 0; i < numInputs; i++) {
                const key = `a${i + 1}`; // prepend 'a' so it doesn't appear as an array
                this.deviceInfo.inputs.push({ code: key, external: true, name: `Input ${i + 1}` });
            }
            for (let i = 0; i < numOutputs; i++) {
                const key = `a${i + 1}`; //prepend 'a' so it doesn't appear as an array
                this.deviceInfo.outputs.push({ code: key, name: `Output ${i + 1}` });
            }
            if (updateDetected) {
                this.state.detected.update({
                    videoInputs: this.deviceInfo.inputs,
                    videoOutputs: this.deviceInfo.outputs,
                });
            }
        });
    }
}
// static properties
JustAddPowerAmp.driverType = 'socketDriver';
JustAddPowerAmp.key = '-NNmhnsG3c299Z3Ylqia';
JustAddPowerAmp.socketOptions = [{ port: 23 }];
